import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "../../../images/close-icon.svg";
// import Cookies from 'js-cookie';
import MenuIcon from "../../../images/hamburger.svg";
import Logo from "../../../images/logo.svg";
import ArrowDown from "../../../assets/arrow-down.svg";

import "./style.css";
import {
  ACCOUNTS_HOSTNAME,
  PAYOUTS_HOSTNAME,
  DOCUMENTATION_HOSTNAME,
  SUPPORT_REDIRECT_URL,
} from "../../../utils/constants";
import Modal from "../../common/Modal";
import ContactUs from "../ContactUs";
import NavDropDown from "./NavDropDown";

// import { useUserDetails } from "../../UserDetails/store";

export interface DropDownOption {
  label: string;
  path: string;
}

const Header: React.FunctionComponent<{}> = () => {
  const [showContactUs, setShowContactUs] = useState(false);

  const openModal = (): void => setShowContactUs(true);
  const closeModal = (): void => {
    setShowContactUs(false);
  };
  // const { openModal } = props;
  const [navClass, setNavClass] = useState("top-0");
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showContactDropdown, setShowContactDropdown] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (showMobileMenu) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [showMobileMenu]);

  useEffect(() => {
    if (window && window?.location?.hash) {
      document
        .getElementById(window.location.hash.substring(1))
        ?.scrollIntoView({
          behavior: "smooth",
        });
    }
  }, []);

  /**
   * Scroll to the section
   */
  const handleScrollToSection = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    section: string
  ): void => {
    if (showMobileMenu) {
      setShowMobileMenu(false);
    }
    e.preventDefault();
    // eslint-disable-next-line no-unused-expressions
    if (!document.getElementById(section)) {
      window.location.replace(`/#${section}`);
      return;
    }
    document.getElementById(section)?.scrollIntoView({
      behavior: "smooth",
    });
  };

  // const { userDetailsState } = useUserDetails();
  // const { data } = userDetailsState.data;
  // const isLoggedIn = Cookies.get("isLoggedIn");

  const navToLogin = (): void => {
    // if (Object.keys(data).length > 0 || isLoggedIn) {
    //   history.push("/dashboard");
    //   return;
    // }

    window.location.href = `${ACCOUNTS_HOSTNAME}/login?redirecturi=${PAYOUTS_HOSTNAME}/dashboard`;
  };

  const navToSignup = (): void => {
    // if (Object.keys(data).length > 0 || isLoggedIn) {
    //   history.push("/dashboard");
    //   return;
    // }

    window.location.href = `${ACCOUNTS_HOSTNAME}/?redirecturi=${PAYOUTS_HOSTNAME}/dashboard`;
  };

  let prevScrollpos;

  if (typeof window !== "undefined") {
    prevScrollpos = window.pageYOffset;
  }
  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    if (prevScrollpos >= currentScrollPos) {
      setNavClass("top-0");
    } else if (prevScrollpos > 0 && currentScrollPos > 600) {
      setNavClass("top-m-50");
      setShowDropdown(false);
    } else {
      setNavClass("top-0");
    }
    prevScrollpos = currentScrollPos;
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);

  const DropdownOptions = [
    { label: t("home.header.navDropdown.aboutUs"), path: "/about" },
    { label: t("home.header.navDropdown.culture"), path: "/culture" },
    { label: t("home.header.navDropdown.career"), path: "/careers" },
  ];

  const ContactDropdownOptions = [
    { label: t("home.header.contactDropdown.contactSales"), path: "/contact" },
    {
      label: t("home.header.contactDropdown.contactSupport"),
      path: SUPPORT_REDIRECT_URL,
      openInNewTab: true,
    },
  ];

  const renderSmallScreenMenu = (
    <div
      className={`bg-background-milk fixed top-0 left-0 right-0 flex sm-menu ${
        showMobileMenu ? "sm-menu-animation" : "h-0"
      }`}
    >
      <div className="sm-wrapper w-full">
        <div className="flex items-center justify-between h-14">
          <Logo className="h-10 w-72" />
          <CloseIcon
            className="cursor-pointer m-2.5"
            width={14}
            height={14}
            onClick={() => {
              setShowMobileMenu(false);
            }}
          />
        </div>
        <div className="flex w-full mt-6 mb-10">
          <button
            type="button"
            onClick={navToLogin}
            className="flex content-center flex-wrap justify-center border-blue-primary w-full max-w-btn h-12 rounded font-semibold text-sm text-celtic-blue-primary border "
          >
            {t("home.header.loginBtnText")}
          </button>
        </div>

        <ul className="flex flex-col w-full overflow-auto h-3/4">
          <li className="navItem p-4 hover:bg-background-dirt-snow rounded-md">
            <h4>
              <a
                className="text-neutral-charcoal block"
                href="/about"
                rel="noopener noreferrer"
                // onClick={(e) => handleScrollToSection(e, "features")}
              >
                {t("home.header.navDropdown.aboutUs")}
              </a>
            </h4>
          </li>

          <li className="navItem p-4 hover:bg-background-dirt-snow rounded-md">
            <h4>
              <a
                className="text-neutral-charcoal block"
                href="/culture"
                rel="noopener noreferrer"
                // onClick={(e) => handleScrollToSection(e, "use-cases")}
              >
                {t("home.header.navDropdown.culture")}
              </a>
            </h4>
          </li>

          <li className="navItem p-4 hover:bg-background-dirt-snow rounded-md">
            <h4>
              <a
                className="text-neutral-charcoal block"
                href="/careers"
                rel="noopener noreferrer"
              >
                {t("home.header.navDropdown.career")}
              </a>
            </h4>
          </li>
          <li className="navItem p-4 hover:bg-background-dirt-snow rounded-md">
            <h4>
              <a
                className="text-neutral-charcoal block whitespace-nowrap"
                href="/contact"
                rel="noopener noreferrer"
              >
                {t("home.header.menu.contactSales")}
              </a>
            </h4>
          </li>
        </ul>
      </div>
    </div>
  );

  return (
    <>
      <Modal
        content={<ContactUs closeModal={closeModal} />}
        show={showContactUs}
        closeModal={closeModal}
      />
      <nav
        className={`fixed  left-0 w-full bg-background-milk z-20 on-scroll ${navClass}`}
      >
        {renderSmallScreenMenu}
        <div className="container mx-auto">
          <div className="flex flex-row py-4 justify-between">
            <div className=" lg:w-1/12 flex content-center items-center justify-between w-full">
              <p className="text-celtic-blue-primary">
                <a href="/">
                  <Logo className="h-10 mr-4" />
                </a>
              </p>
              <MenuIcon
                className="mt-1 block lg:hidden cursor-pointer"
                width={24}
                height={24}
                onClick={() => {
                  setShowMobileMenu(true);
                }}
              />
            </div>

            <div className="w-full lg:w-7/12 flex-row content-center flex-wrap text-neutral-charcoal order-3 lg:order-2 hidden lg:flex">
              <div className="w-full flex flex-row font-semibold text-base justify-center pt-6 lg:pt-0">
                <ul className="flex lg:justify-center w-full">
                  <li className="navItem pr-6 lg:px-6 flex items-center">
                    <h5>
                      <a
                        className="text-neutral-charcoal whitespace-nowrap"
                        href="/about"
                        rel="noopener noreferrer"
                      >
                        {t("home.header.navDropdown.aboutUs")}
                      </a>
                    </h5>
                  </li>

                  <li className="navItem pr-6 lg:px-6 flex items-center min-fit">
                    <h5>
                      <a
                        className="text-neutral-charcoal whitespace-nowrap"
                        href="/culture"
                        rel="noopener noreferrer"
                      >
                        {t("home.header.navDropdown.culture")}
                      </a>
                    </h5>
                  </li>

                  <li className="navItem pr-6 lg:px-6 flex items-center">
                    <h5>
                      <a
                        className="text-neutral-charcoal"
                        href="/careers"
                        rel="noopener noreferrer"
                      >
                        {t("home.header.navDropdown.career")}
                      </a>
                    </h5>
                  </li>
                  <li className="navItem pr-6 lg:px-6 flex items-center">
                    <h5>
                      <a
                        className="text-neutral-charcoal"
                        href="/contact"
                        rel="noopener noreferrer"
                      >
                        {t("home.header.menu.contact")}
                      </a>
                    </h5>
                  </li>
                </ul>
              </div>
            </div>
            <div className="hidden lg:flex justify-end items-center lg:order-3">
              <button
                type="button"
                onClick={navToLogin}
                className="flex content-center flex-wrap justify-center border-blue-primary w-20 h-10 rounded font-semibold text-sm text-celtic-blue-primary border "
              >
                {t("home.header.loginBtnText")}
              </button>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
export default Header;
